import Modal from '../../..';
import Form from '../../../../Form';
import useStore from '../../../../Hooks/useStore';

const ModalLogisticOriginUpdate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateLogisticOrigin');
  const onClose = () => {
    closeSingleModal('updateLogisticOrigin');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar logística origem"
      height={'auto'}
      width={'60vw'}
      backgroundColor={'#ececec'}
    >
      <Form.Export.Logistic.Origin.Update />
    </Modal>
  );
};

export default ModalLogisticOriginUpdate;
